import { render } from "./ComplianceApprovalDialog.vue?vue&type=template&id=5cecbb7d"
import script from "./ComplianceApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceApprovalDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__